import { render, staticRenderFns } from "./car_detail.vue?vue&type=template&id=b6e80b3c&"
import script from "./car_detail.vue?vue&type=script&lang=js&"
export * from "./car_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports